// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-btn {
  min-height: 4rem;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0px 4px 4px var(--black-250);
  font-family: "Inter", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 1rem 2.5rem;
  position: relative;
  transition: 200ms all ease-in-out;
}
.base-btn.icon-only {
  width: 4rem;
  min-width: 4rem;
  min-height: 4rem;
  padding: 1rem;
}
.base-btn.icon-only .icon {
  width: 1.5rem;
  height: 1.5rem;
  transition: 200ms all ease-in-out;
}
.base-btn .start-icon,
.base-btn .end-icon {
  width: 1.5rem;
  height: 1.5rem;
  transition: 200ms all ease-in-out;
}
.base-btn.primary-btn {
  --primary-btn-text: var(--white-1000);
  background-color: var(--primaryMain-1000);
  color: var(--primary-btn-text);
}
.base-btn.primary-btn svg {
  fill: var(--primary-btn-text);
}
.base-btn.secondary-btn {
  --secondary-btn-text: var(--black-1000);
  background-color: var(--secondaryMain-1000);
  color: var(--secondary-btn-text);
}
.base-btn.secondary-btn svg {
  fill: var(--secondary-btn-text);
}
.base-btn.tertiary-btn {
  --tertiary-btn-text: var(--white-1000);
  background-color: var(--tertiaryMain-1000);
  color: var(--tertiary-btn-text);
}
.base-btn.tertiary-btn svg {
  fill: var(--tertiary-btn-text);
}
.base-btn.quaternary-btn {
  --quaternary-btn-text: var(--white-1000);
  background-color: var(--quaternaryMain-1000);
  color: var(--quaternary-btn-text);
}
.base-btn.quaternary-btn svg {
  fill: var(--quaternary-btn-text);
}
.base-btn.black-btn {
  --grey-btn-text: var(--secondaryMain-1000);
  background-color: var(--black-1000);
  color: var(--grey-btn-text);
}
.base-btn.black-btn svg {
  fill: var(--grey-btn-text);
}
.base-btn.grey-btn {
  --grey-btn-text: var(--secondaryMain-1000);
  background-color: var(--blackCoral-1000);
  color: var(--grey-btn-text);
}
.base-btn.grey-btn svg {
  fill: var(--grey-btn-text);
}
.base-btn.default-btn {
  --default-btn-text: var(--indigo-1000);
  background-color: var(--white-1000);
  color: var(--default-btn-text);
}
.base-btn.default-btn svg {
  fill: var(--default-btn-text);
}
.base-btn:hover:not(:disabled) {
  transform: scale(0.95);
}
.base-btn:active:not(:disabled) {
  transform: scale(0.85);
}
.base-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media screen and (max-width: 991.98px) {
  .base-btn {
    min-height: 2.5rem;
    border-radius: 0.75rem;
    font-size: 1rem;
    padding: 0.5rem 1.25rem;
  }
  .base-btn.icon-only {
    width: 2.5rem;
    min-width: 2.5rem;
    min-height: 2.5rem;
  }
  .base-btn.icon-only .icon {
    width: 1.125rem;
    height: 1.125rem;
  }
  .base-btn .start-icon,
  .base-btn .end-icon {
    width: 1.125rem;
    height: 1.125rem;
  }
}
@media screen and (max-width: 767.98px) {
  .base-btn {
    min-height: 2.25rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1.25rem;
  }
  .base-btn.icon-only {
    width: 2.25rem;
    min-width: 2.25rem;
    min-height: 2.25rem;
  }
  .base-btn.icon-only .icon {
    width: 1.125rem;
    height: 1.125rem;
  }
  .base-btn .start-icon,
  .base-btn .end-icon {
    width: 1rem;
    height: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/CustomButton/CustomButtonStyle.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,wCAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iCAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACE,aAAA;EACA,cAAA;EACA,iCAAA;AACN;AAGE;;EAEE,aAAA;EACA,cAAA;EACA,iCAAA;AADJ;AAOE;EACE,qCAAA;EACA,yCAAA;EACA,8BAAA;AALJ;AAOI;EACE,6BAAA;AALN;AAYE;EACE,uCAAA;EACA,2CAAA;EACA,gCAAA;AAVJ;AAYI;EACE,+BAAA;AAVN;AAiBE;EACE,sCAAA;EACA,0CAAA;EACA,+BAAA;AAfJ;AAiBI;EACE,8BAAA;AAfN;AAsBE;EACE,wCAAA;EACA,4CAAA;EACA,iCAAA;AApBJ;AAsBI;EACE,gCAAA;AApBN;AA2BE;EACE,0CAAA;EACA,mCAAA;EACA,2BAAA;AAzBJ;AA2BI;EACE,0BAAA;AAzBN;AAgCE;EACE,0CAAA;EACA,wCAAA;EACA,2BAAA;AA9BJ;AAgCI;EACE,0BAAA;AA9BN;AAqCE;EACE,sCAAA;EACA,mCAAA;EACA,8BAAA;AAnCJ;AAqCI;EACE,6BAAA;AAnCN;AAuCE;EACE,sBAAA;AArCJ;AAwCE;EACE,sBAAA;AAtCJ;AAyCE;EACE,YAAA;EACA,mBAAA;AAvCJ;AA0CE;EAhJF;IAiJI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,uBAAA;EAvCF;EAyCE;IACE,aAAA;IACA,iBAAA;IACA,kBAAA;EAvCJ;EAyCI;IACE,eAAA;IACA,gBAAA;EAvCN;EA2CE;;IAEE,eAAA;IACA,gBAAA;EAzCJ;AACF;AA4CE;EAxKF;IAyKI,mBAAA;IACA,qBAAA;IACA,mBAAA;IACA,uBAAA;EAzCF;EA2CE;IACE,cAAA;IACA,kBAAA;IACA,mBAAA;EAzCJ;EA2CI;IACE,eAAA;IACA,gBAAA;EAzCN;EA6CE;;IAEE,WAAA;IACA,YAAA;EA3CJ;AACF","sourcesContent":[".base-btn {\n  min-height: 4rem;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0px 4px 4px var(--black-250);\n  font-family: \"Inter\", sans-serif;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  text-transform: uppercase;\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 1rem 2.5rem;\n  position: relative;\n  transition: 200ms all ease-in-out;\n\n  &.icon-only {\n    width: 4rem;\n    min-width: 4rem;\n    min-height: 4rem;\n    padding: 1rem;\n\n    .icon {\n      width: 1.5rem;\n      height: 1.5rem;\n      transition: 200ms all ease-in-out;\n    }\n  }\n\n  .start-icon, \n  .end-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n    transition: 200ms all ease-in-out;\n  }\n\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // PRIMARY BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.primary-btn {\n    --primary-btn-text: var(--white-1000);\n    background-color: var(--primaryMain-1000);\n    color: var(--primary-btn-text);\n\n    svg {\n      fill: var(--primary-btn-text);\n    }\n  }\n\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // SECONDARY BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.secondary-btn {\n    --secondary-btn-text: var(--black-1000);\n    background-color: var(--secondaryMain-1000);\n    color: var(--secondary-btn-text);\n\n    svg {\n      fill: var(--secondary-btn-text);\n    }\n  }\n  \n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // TERTIARY BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.tertiary-btn {\n    --tertiary-btn-text: var(--white-1000);\n    background-color: var(--tertiaryMain-1000);\n    color: var(--tertiary-btn-text);\n\n    svg {\n      fill: var(--tertiary-btn-text);\n    }\n  }\n  \n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // QUATERNARY BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.quaternary-btn {\n    --quaternary-btn-text: var(--white-1000);\n    background-color: var(--quaternaryMain-1000);\n    color: var(--quaternary-btn-text);\n\n    svg {\n      fill: var(--quaternary-btn-text);\n    }\n  }\n\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // BLACK BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.black-btn {\n    --grey-btn-text: var(--secondaryMain-1000);\n    background-color: var(--black-1000);\n    color: var(--grey-btn-text);\n\n    svg {\n      fill: var(--grey-btn-text);\n    }\n  }\n  \n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // GREY BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.grey-btn {\n    --grey-btn-text: var(--secondaryMain-1000);\n    background-color: var(--blackCoral-1000);\n    color: var(--grey-btn-text);\n\n    svg {\n      fill: var(--grey-btn-text);\n    }\n  }\n  \n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  // DEFAULT BUTTON START\n  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@\n  &.default-btn {\n    --default-btn-text: var(--indigo-1000);\n    background-color: var(--white-1000);\n    color: var(--default-btn-text);\n\n    svg {\n      fill: var(--default-btn-text);\n    }\n  }\n\n  &:hover:not(:disabled) {\n    transform: scale(0.95);\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.85);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    min-height: 2.5rem;\n    border-radius: 0.75rem;\n    font-size: 1rem;\n    padding: 0.5rem 1.25rem;\n\n    &.icon-only {\n      width: 2.5rem;\n      min-width: 2.5rem;\n      min-height: 2.5rem;\n\n      .icon {\n        width: 1.125rem;\n        height: 1.125rem;\n      }\n    }\n    \n    .start-icon, \n    .end-icon {\n      width: 1.125rem;\n      height: 1.125rem;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    min-height: 2.25rem;\n    border-radius: 0.5rem;\n    font-size: 0.875rem;\n    padding: 0.5rem 1.25rem;\n\n    &.icon-only {\n      width: 2.25rem;\n      min-width: 2.25rem;\n      min-height: 2.25rem;\n\n      .icon {\n        width: 1.125rem;\n        height: 1.125rem;\n      }\n    }\n    \n    .start-icon, \n    .end-icon {\n      width: 1rem;\n      height: 1rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
